import axios from 'axios'
import qs from 'qs'
import service from '@/services';
function tableDownLoad({ method = 'post', url, data, params, fileName, fileSuffix = 'xls', isFormData = true }) {
  return axios({
    method: method,
    url: url,
    data: isFormData ? qs.stringify(data) : data,
    params: params,
    headers: {
      'content-type': isFormData ? 'application/x-www-form-urlencoded;charset=UTF-8' : 'application/json;charset=UTF-8',
      token: service.state.token,
    },
    responseType: 'blob'
  }).then(async res => {
    const content = res.data
    if (content.type === 'application/json') {
      const enc = new TextDecoder('utf-8')
      const buffer = await content.arrayBuffer()
      const data = JSON.parse(enc.decode(new Uint8Array(buffer))) || {}
      return Promise.resolve(data)
    }
    const blob = new Blob([content])
    let fileNames = ''
    if (fileName && fileSuffix && fileSuffix !== 'auto') {
      fileNames = fileName + '.' + fileSuffix
    } else {
      const disposition = res.headers['content-disposition'] || ''
      fileNames = disposition.split(';')[1].split('=')[1]
      fileNames = decodeURIComponent(fileNames)
    }
    if ('download' in document.createElement('a')) {
      // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileNames
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, fileNames)
    }
    return true
  })
}
export default tableDownLoad
